var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmsFeatureAblaufgrafikMobilStep1Rgb = function SvgSmsFeatureAblaufgrafikMobilStep1Rgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "schrift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,173.8H198.3v-4.5c0-14.2-9.9-25.8-22.1-25.8h-.5c-2.6-16-14.6-28.1-29-28.1a24.7,24.7,0,0,0-8.6,1.5C131.4,101.5,117.7,91,101.9,91s-29,10.2-35.8,25.2a24.8,24.8,0,0,0-6.1-.7c-14.5,0-26.6,12.3-29.1,28.4a22,22,0,0,0-3.6-.4c-12.2,0-22.1,11.5-22.1,25.8v4.5Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,173.8H265.9v-3.7A22.1,22.1,0,0,0,243.8,148h-.5a29.6,29.6,0,0,0-29.1-24.1,27.1,27.1,0,0,0-8.6,1.3,40.6,40.6,0,0,0-72.1-.6,30.8,30.8,0,0,0-6.1-.6,29.5,29.5,0,0,0-29.1,24.4,21.9,21.9,0,0,0-3.6-.3,22.1,22.1,0,0,0-22.1,22.1v3.6Z",
    style: {
      fill: "var(--ca-primary-color-lighter, #5fcced)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,173.8H296.4V171c0-8.9-7.9-16-17.6-16h-.4c-2-9.9-11.6-17.5-23.1-17.5a24.8,24.8,0,0,0-6.8.9c-5.3-9.6-16.2-16.1-28.8-16.1s-23.1,6.3-28.5,15.6a26.1,26.1,0,0,0-4.8-.5c-11.6,0-21.2,7.6-23.1,17.7l-2.9-.2c-9.7,0-17.6,7.2-17.6,16v2.9Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152,157.4v-1.8a40.9,40.9,0,0,0,6-.7l.3,1.8A61.8,61.8,0,0,1,152,157.4Zm-5.1-.1c-2-.1-4.1-.3-6.1-.6l.3-1.8a55.4,55.4,0,0,0,6,.6Zm-11-1.6a45,45,0,0,1-6-1.7l.6-1.7a55.4,55.4,0,0,0,5.8,1.7Zm27.2,0-.4-1.8q2.9-.7,5.7-1.8l.6,1.7Zm-37.9-3.5-5.5-2.8.9-1.6a45.3,45.3,0,0,0,5.4,2.7Zm48.5-.4-.8-1.6a53.9,53.9,0,0,0,5.2-3l.9,1.6A55.4,55.4,0,0,1,173.7,151.8Zm-58.2-5.2a45.4,45.4,0,0,1-4.8-3.9l1.2-1.3a53.2,53.2,0,0,0,4.6,3.7Zm67.7-.8-1.1-1.4a41.9,41.9,0,0,0,4.5-3.9l1.3,1.3A58.5,58.5,0,0,1,183.2,145.8Zm-76.1-6.7c-1.3-1.6-2.6-3.2-3.8-4.9l1.5-1a54.5,54.5,0,0,0,3.7,4.7Zm84.3-1L190,137c1.3-1.5,2.5-3.1,3.7-4.7l1.5,1C194,135,192.7,136.6,191.4,138.1Zm-90.8-8.2a56,56,0,0,1-2.7-5.5l1.6-.7a52.8,52.8,0,0,0,2.7,5.3Zm97.3-.9-1.6-.9a33.6,33.6,0,0,0,2.6-5.4l1.7.8C199.8,125.3,198.9,127.2,197.9,129ZM96.1,119.6a56.9,56.9,0,0,1-1.6-5.9l1.8-.4c.4,1.9.9,3.9,1.5,5.8Zm106.3-.9-1.8-.6a37,37,0,0,0,1.6-5.7l1.7.3Q203.3,115.7,202.4,118.7Zm-108.7-10c-.2-2.1-.4-4.1-.4-6.2h1.8a56.5,56.5,0,0,0,.4,5.9Zm111-1-1.8-.2c.2-2,.3-4,.3-5.9v-3H205v3.1C205,103.6,204.9,105.7,204.7,107.7ZM95.2,97.6l-1.8-.2c.2-2,.4-4.1.8-6.1l1.7.3C95.6,93.6,95.4,95.6,95.2,97.6Zm107.5-3.8a56,56,0,0,0-1.2-5.9l1.7-.4a40,40,0,0,1,1.3,6ZM97,86.8l-1.7-.4a40.6,40.6,0,0,1,1.9-5.9l1.6.7A52.2,52.2,0,0,0,97,86.8Zm103-3.6a37.6,37.6,0,0,0-2.3-5.5l1.6-.8q1.3,2.8,2.4,5.7Zm-99.2-6.5-1.6-.8a46.8,46.8,0,0,1,3-5.4l1.6,1A44,44,0,0,0,100.8,76.7Zm94.5-3.3a52.5,52.5,0,0,0-3.3-4.9l1.4-1.1c1.2,1.6,2.4,3.3,3.5,5.1Zm-88.7-5.9-1.4-1.1a61,61,0,0,1,4.1-4.6l1.3,1.2A42.8,42.8,0,0,0,106.6,67.5Zm82.2-2.7a56.6,56.6,0,0,0-4.3-4.2l1.2-1.3a57.7,57.7,0,0,1,4.4,4.2Zm-74.6-5-1.1-1.4a57.4,57.4,0,0,1,5-3.6l1,1.5A40,40,0,0,0,114.2,59.8Zm66.4-2.2a52.9,52.9,0,0,0-5-3.2l.9-1.6c1.7,1,3.5,2.1,5.2,3.3Zm-57.3-3.8-.8-1.6,5.6-2.5.7,1.7A53.8,53.8,0,0,0,123.3,53.8Zm47.9-1.6a54.2,54.2,0,0,0-5.6-2.2l.6-1.7,5.7,2.2Zm-37.8-2.3-.5-1.8c2-.5,4-1,6-1.3l.4,1.7A56.3,56.3,0,0,0,133.4,49.9Zm27.5-1.1a40.4,40.4,0,0,0-5.9-1l.2-1.8c2,.2,4.1.6,6.1,1Zm-16.8-1-.2-1.8c1.7-.1,3.4-.3,5.1-.3h1.1v1.8H149Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,167.5l-3.4-.2v-1.8l3.4.2h2.5v1.8Zm7.8-.5-.2-1.8c1.9-.2,3.9-.6,5.9-1l.3,1.8Zm-16.3-.3c-2-.2-4-.6-6-1l.4-1.8L141,165Zm27.2-2-.5-1.7c1.9-.6,3.8-1.2,5.7-2l.6,1.7Zm-38.1-.2-5.8-2,.6-1.7a54.4,54.4,0,0,0,5.7,1.9Zm48.6-3.9-.8-1.6,5.2-2.9.9,1.5A55.4,55.4,0,0,1,178.4,160.6Zm-59.1-.1a56.1,56.1,0,0,1-5.4-2.9l.9-1.5c1.7,1,3.5,1.9,5.3,2.8Zm68.6-5.7-1-1.5a41.4,41.4,0,0,0,4.6-3.7l1.2,1.4C191.2,152.3,189.6,153.6,187.9,154.8Zm-78.2,0c-1.7-1.2-3.3-2.5-4.9-3.8l1.2-1.4a55.8,55.8,0,0,0,4.7,3.8Zm86.7-7.3-1.3-1.3a58.2,58.2,0,0,0,4-4.5l1.4,1.2Zm-95.2,0a58.5,58.5,0,0,1-4-4.7l1.4-1.1a41.9,41.9,0,0,0,3.9,4.5Zm102.3-8.7-1.5-1c1.2-1.7,2.2-3.4,3.2-5.1l1.6.9A56.9,56.9,0,0,1,203.5,138.8Zm-109.3-.1a56.4,56.4,0,0,1-3.1-5.3l1.5-.8c1,1.7,2,3.5,3.1,5.1Zm114.9-9.6-1.7-.8c.9-1.8,1.6-3.7,2.3-5.5l1.7.6C210.7,125.3,209.9,127.2,209.1,129.1Zm-120.2-.2a57.7,57.7,0,0,1-2.2-5.8l1.7-.6a53.7,53.7,0,0,0,2.1,5.6Zm124-10.4-1.8-.5a54.3,54.3,0,0,0,1.3-5.8l1.8.3C213.8,114.5,213.4,116.5,212.9,118.5Zm-127.6-.3a57.9,57.9,0,0,1-1.2-6l1.8-.3c.3,2,.7,4,1.1,5.9Zm129.5-10.7-1.8-.2q.3-3,.3-6h1.8C215.1,103.4,215,105.4,214.8,107.5Zm-131.3-.3c-.1-1.8-.2-3.6-.2-5.4V101h1.8v.7c0,1.7.1,3.5.2,5.2ZM213.1,96.8c-.1-1.9-.4-3.9-.7-5.9l1.8-.3c.3,2,.5,4.1.7,6.1ZM85.3,96.1H83.5c.2-2.1.4-4.1.7-6.1l1.8.3A56,56,0,0,0,85.3,96.1Zm126.1-10c-.5-1.9-1.1-3.9-1.7-5.7l1.7-.6c.6,1.9,1.2,3.9,1.7,5.9ZM87,85.4l-1.7-.5c.5-2,1-3.9,1.7-5.9l1.7.6C88.1,81.5,87.5,83.4,87,85.4Zm120.8-9.6c-.8-1.8-1.7-3.6-2.6-5.4l1.5-.8a47.3,47.3,0,0,1,2.8,5.5ZM90.5,75l-1.7-.7,2.7-5.5,1.6.8C92.2,71.4,91.3,73.2,90.5,75Zm112.1-8.8-3.5-4.8,1.4-1.1c1.2,1.6,2.5,3.2,3.6,4.9ZM95.7,65.4l-1.5-1a56,56,0,0,1,3.6-4.9l1.4,1.1A53.4,53.4,0,0,0,95.7,65.4Zm100.1-7.7c-1.3-1.4-2.8-2.8-4.3-4.2l1.2-1.3a59.3,59.3,0,0,1,4.4,4.3Zm-93.4-.8-1.3-1.2q2.3-2.2,4.5-4.2l1.2,1.3Zm85.3-6.5c-1.6-1.2-3.3-2.3-4.9-3.3l.9-1.6,5.1,3.5Zm-77-.6-1.1-1.5a56.9,56.9,0,0,1,5.2-3.3l.9,1.5A53.9,53.9,0,0,0,110.7,49.8Zm67.8-5.2L173,42.1l.7-1.6a56.2,56.2,0,0,1,5.6,2.5ZM120,44.3l-.7-1.7,5.6-2.4.7,1.7A55.5,55.5,0,0,0,120,44.3Zm48.4-3.8c-1.9-.6-3.9-1.2-5.8-1.6l.4-1.7a56.6,56.6,0,0,1,5.9,1.5Zm-38.2-.1-.5-1.7q3-.9,6-1.5l.4,1.8Zm10.7-2.2-.2-1.8a60,60,0,0,1,6.1-.6v1.8Q143.9,37.8,140.9,38.2Zm16.8-.1a56.1,56.1,0,0,0-5.9-.6V35.7c2,.1,4.1.3,6.1.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.4,170.2H121a9.9,9.9,0,0,1-9.9-9.9V45.5a9.9,9.9,0,0,1,9.9-9.9h58.4a9.9,9.9,0,0,1,9.9,9.9V160.3A9.9,9.9,0,0,1,179.4,170.2Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.1,166.2H121.4a5.9,5.9,0,0,1-5.9-5.8V45.5a5.9,5.9,0,0,1,5.9-5.9h57.7a5.9,5.9,0,0,1,5.9,5.9V160.4A5.9,5.9,0,0,1,179.1,166.2Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.3,169.6H120.9a9.9,9.9,0,0,1-9.9-9.9V45a9.9,9.9,0,0,1,9.9-9.9h58.4a9.9,9.9,0,0,1,10,9.9V159.7A9.9,9.9,0,0,1,179.3,169.6Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8,131.8H121a1.4,1.4,0,0,1-1.4-1.4v-7.2a1.4,1.4,0,0,1,1.4-1.4h59.8a1.4,1.4,0,0,1,1.4,1.4v7.2A1.4,1.4,0,0,1,180.8,131.8Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.6,
    y: 105.9,
    width: 63.7,
    height: 10.49,
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 47,
    width: 63.7,
    height: 11.77,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 62.8,
    width: 63.7,
    height: 31.3,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.5,111.1a6.6,6.6,0,0,1-.4,2.8,1.6,1.6,0,0,1-1.5.8,1.6,1.6,0,0,1-1.4-.8,6.3,6.3,0,0,1-.5-2.8,6.2,6.2,0,0,1,.5-2.7,1.5,1.5,0,0,1,1.4-.9,1.6,1.6,0,0,1,1.5.9A6.1,6.1,0,0,1,125.5,111.1Zm-2.5,0a7.5,7.5,0,0,0,.2,2,.5.5,0,0,0,.4.5l.4-.2a1.2,1.2,0,0,0,.2-.7c0-.4.1-.9.1-1.6a7.1,7.1,0,0,0-.2-1.9c-.1-.4-.2-.5-.5-.5s-.4.1-.4.5A7.1,7.1,0,0,0,123,111.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,114.6h-1.3v-4.1a8.6,8.6,0,0,1,.1-1.5l-.3.3-.8.9-.7-.8,1.8-1.7h1.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5,114.6h-3.7v-.9l1.2-1.8a3.8,3.8,0,0,0,.7-1.1l.3-.6a2,2,0,0,0,.1-.7.8.8,0,0,0-.2-.6l-.5-.2H132l-.6.5-.7-.8.9-.7a1.6,1.6,0,0,1,1-.2,1.5,1.5,0,0,1,1.3.5,1.7,1.7,0,0,1,.5,1.3c0,.3-.1.5-.1.8l-.3.7a5.9,5.9,0,0,1-.4.8l-1.4,1.7h2.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.9,109.2a1.8,1.8,0,0,1-.3,1.1,2.1,2.1,0,0,1-1,.6h0a1.9,1.9,0,0,1,1.1.5,1.8,1.8,0,0,1,.3,1.1,1.8,1.8,0,0,1-.6,1.5,2.1,2.1,0,0,1-1.6.6,4.1,4.1,0,0,1-1.6-.3v-1.2a1.1,1.1,0,0,0,.7.3h.7c.4,0,.7,0,.9-.2a1.9,1.9,0,0,0,.2-.8c0-.7-.4-1.1-1.2-1.1h-.4v-.9h.3a1.2,1.2,0,0,0,.9-.3,1,1,0,0,0,.3-.8.8.8,0,0,0-.2-.6c-.1-.2-.3-.2-.5-.2a1.7,1.7,0,0,0-1.1.4l-.6-.8a2.4,2.4,0,0,1,1.8-.7,2,2,0,0,1,1.4.4A1.7,1.7,0,0,1,138.9,109.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,113.2h-.7v1.4h-1.2v-1.4H142v-1.1l2.1-4.4h1.4v4.4h.7Zm-1.9-1.1v-2.7h-.1l-.3.9-.9,1.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.8,110.3a1.3,1.3,0,0,1,1.2.5,2.8,2.8,0,0,1-.1,3.3,2.1,2.1,0,0,1-1.6.6,3.3,3.3,0,0,1-1.5-.3v-1.2l.6.3h.8c.6,0,1-.4,1-1.2a1,1,0,0,0-1-1.1l-.9.2-.4-.4.2-3.4h3v1.1h-1.9v1.5Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,111.7a6.5,6.5,0,0,1,.6-3.2,2.4,2.4,0,0,1,2-.9h.8v1.1H154a1.1,1.1,0,0,0-.8.3,1.1,1.1,0,0,0-.6.7,4.4,4.4,0,0,0-.2,1.3h.1a2.1,2.1,0,0,1,.4-.6l.7-.2a1.3,1.3,0,0,1,1.1.6,3.4,3.4,0,0,1,.4,1.6,3.2,3.2,0,0,1-.5,1.8,2,2,0,0,1-1.4.6,1.6,1.6,0,0,1-1.5-.8A4.3,4.3,0,0,1,151.3,111.7Zm1.9,1.9c.2,0,.3-.1.4-.3a2.2,2.2,0,0,0,.2-1,1.9,1.9,0,0,0-.2-.8c-.1-.2-.2-.3-.4-.3a.5.5,0,0,0-.5.3,1.4,1.4,0,0,0-.2.7,3.1,3.1,0,0,0,.2,1.1A.5.5,0,0,0,153.2,113.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,114.6l1.9-5.8h-2.4v-1.1h3.7v.8l-1.9,6.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,107.6a1.7,1.7,0,0,1,1.3.4,1.9,1.9,0,0,1,.5,1.3,2.9,2.9,0,0,1-.2.9,2.9,2.9,0,0,1-.8.7,3.8,3.8,0,0,1,.9.9,3.6,3.6,0,0,1,.2,1,1.7,1.7,0,0,1-.5,1.4,2,2,0,0,1-1.4.5,1.6,1.6,0,0,1-1.4-.5,1.7,1.7,0,0,1-.5-1.3,3.6,3.6,0,0,1,.2-1.1,3,3,0,0,1,.8-.8l-.7-.8a2.9,2.9,0,0,1-.2-.9,1.9,1.9,0,0,1,.5-1.3A2,2,0,0,1,164.6,107.6Zm-.7,5.2a1.4,1.4,0,0,0,.2.7l.5.2.5-.2a1.4,1.4,0,0,0,.2-.7c0-.2-.1-.4-.1-.6a1.7,1.7,0,0,0-.6-.6h0l-.5.6A1.4,1.4,0,0,0,163.9,112.8Zm.7-4.2c-.2,0-.3,0-.4.2a.7.7,0,0,0-.1.5,1.3,1.3,0,0,0,.1.6l.4.5c.2-.2.4-.3.4-.5a1.4,1.4,0,0,0,.2-.6C165.2,108.8,165,108.6,164.6,108.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,110.7c0,2.7-.9,4-2.7,4h-.7v-1h.6a1.4,1.4,0,0,0,1.2-.6,2.7,2.7,0,0,0,.4-1.7h0l-.4.6-.7.2a1.1,1.1,0,0,1-1.1-.6,2.5,2.5,0,0,1-.4-1.6,3.2,3.2,0,0,1,.5-1.8,1.7,1.7,0,0,1,1.4-.6,1.4,1.4,0,0,1,1.4.8A4.6,4.6,0,0,1,171,110.7Zm-1.9-2a.5.5,0,0,0-.5.3,2.5,2.5,0,0,0-.1,1,1.9,1.9,0,0,0,.1.8.5.5,0,0,0,.5.3.5.5,0,0,0,.4-.3.8.8,0,0,0,.2-.7,2.8,2.8,0,0,0-.1-1C169.4,108.8,169.3,108.7,169.1,108.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,111.1a6.3,6.3,0,0,1-.5,2.8,1.6,1.6,0,0,1-1.5.8,1.6,1.6,0,0,1-1.4-.8,6.3,6.3,0,0,1-.5-2.8,6.2,6.2,0,0,1,.5-2.7,1.6,1.6,0,0,1,1.5-.9,1.5,1.5,0,0,1,1.4.9A5.9,5.9,0,0,1,175.6,111.1Zm-2.6,0a7.5,7.5,0,0,0,.2,2,.5.5,0,0,0,.4.5l.4-.2a1.2,1.2,0,0,0,.2-.7c0-.4.1-.9.1-1.6a7.1,7.1,0,0,0-.2-1.9c-.1-.4-.2-.5-.5-.5s-.4.1-.4.5A7.1,7.1,0,0,0,173,111.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,114.6h-1.3v-4.1a8.6,8.6,0,0,1,.1-1.5l-.3.3-.8.9-.7-.8,1.8-1.7h1.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.7,114a4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7l-8.6-14.5a3.9,3.9,0,0,0-6.8,4l15.6,26.3a.4.4,0,0,1-.6.6l-5.9-3.5a4,4,0,0,0-5.4,1.1,3.9,3.9,0,0,0,1.1,5.4,99.7,99.7,0,0,0,11.8,6.6c6.5,2.9,13.9,6.5,20.1,4.5,10.2-3.4,10.6-9.8,10.6-13a44.9,44.9,0,0,0-5.4-19.4l-3.7-6.3A4.1,4.1,0,0,0,207.7,114Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-light, #00a2d4)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.8,11.6H38.3V9.8h8.9v1.8H43.8v10h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,9.8h7.1v1.8h-5v3h4.2v1.7H51.3v3.5h5.2v1.8H49.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,9.8H61v10h4.9v1.8h-7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,9.8H75v1.8H70v3h4.2v1.7H70v3.5h5.2v1.8H67.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6,9.8h7.1v1.8h-5v3.3H84v1.8H79.7v4.9H77.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,15.6c0-3.8,2.1-6,5.2-6s5.2,2.2,5.2,6-2.1,6.2-5.2,6.2S86,19.5,86,15.6Zm8.2,0c0-2.6-1.2-4.2-3-4.2s-3.1,1.6-3.1,4.2S89.3,20,91.2,20,94.2,18.3,94.2,15.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,9.8h2.2l3.7,6.6,1.2,2.5h0c-.1-1.2-.2-2.7-.2-4V9.8h2V21.6h-2.2L101.7,15l-1.2-2.6h0c.1,1.3.2,2.7.2,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5,9.8h2.2l3.7,6.6,1.2,2.5h0c0-1.2-.2-2.7-.2-4V9.8h2V21.6h-2.2L113.6,15l-1.3-2.6h0c.1,1.3.2,2.7.2,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,16.4V9.8h2.1v6.8c0,2.5.9,3.4,2.4,3.4s2.4-.9,2.4-3.4V9.8h2v6.6c0,3.9-1.7,5.4-4.4,5.4S122.3,20.3,122.3,16.4Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,9.8h2.4l2.1,5.8c.2.7.5,1.5.7,2.3h.1c.3-.8.5-1.6.8-2.3l2-5.8h2.4V21.6h-2V16.2c0-1.1.2-2.7.3-3.8h-.1l-.9,2.8L140,20.5h-1.3l-1.9-5.3-1-2.8h0c.1,1.1.2,2.7.2,3.8v5.4h-1.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,9.8h2.3l2.1,5.8c.3.7.5,1.5.8,2.3h0c.3-.8.5-1.6.8-2.3l2-5.8H158V21.6h-1.9V16.2c0-1.1.1-2.7.2-3.8h-.1l-.9,2.8-1.9,5.3h-1.3l-1.9-5.3-1-2.8h0c.1,1.1.2,2.7.2,3.8v5.4h-1.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,9.8h7.1v1.8h-5v3h4.2v1.7h-4.2v3.5h5.1v1.8H161Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6,9.8h4c2.5,0,4.3.9,4.3,3.5a3.3,3.3,0,0,1-2.3,3.4l2.8,4.9h-2.3L174.5,17h-1.8v4.6h-2.1Zm3.8,5.5c1.6,0,2.5-.7,2.5-2s-.9-1.8-2.5-1.8h-1.7v3.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,9.8H192v1.8h-5v3h4.2v1.7H187v3.5h5.2v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.6,9.8h2.1V21.6h-2.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,9.8h2.1l3.7,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V9.8h2V21.6h-2.2L202.7,15l-1.2-2.6h-.1c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,15.7c0-3.8,2.4-6.1,5.5-6.1a4.8,4.8,0,0,1,3.6,1.5l-1.1,1.3a3.5,3.5,0,0,0-2.4-1c-2.1,0-3.5,1.6-3.5,4.3s1.2,4.3,3.6,4.3a2.9,2.9,0,0,0,1.7-.5V16.9h-2.2V15.2h4.1v5.2a5.5,5.5,0,0,1-3.8,1.4C213.2,21.8,210.9,19.6,210.9,15.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,9.8h7.1v1.8h-5v3h4.2v1.7h-4.2v3.5H230v1.8h-7.2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,9.8h3.7c2.5,0,4.2.7,4.2,2.9a2.8,2.8,0,0,1-1.6,2.6h0a2.7,2.7,0,0,1,2.2,2.8c0,2.4-1.9,3.5-4.5,3.5h-4Zm3.5,4.9c1.7,0,2.4-.7,2.4-1.7s-.8-1.6-2.3-1.6h-1.6v3.3Zm.3,5.3c1.7,0,2.7-.7,2.7-2s-.9-1.8-2.7-1.8h-1.8V20Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,9.8h7.1v1.8h-5v3h4.2v1.7h-4.2v3.5h5.2v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,9.8H255l3.7,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V9.8h2V21.6h-2.1L255.9,15l-1.2-2.6h-.1c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmsFeatureAblaufgrafikMobilStep1Rgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-feature-ablaufgrafik-mobil-step1-rgb.31c1b4ce9b4204b2bcfa26c02642ecf1.svg";